export const ScoreRing = ({ score, passed, size = 150 }) => {
  const r = 60;
  const c = 2 * Math.PI * r;
  const color = passed ? "hsl(var(--primary))" : "hsl(var(--error))";
  return (
    <div className="relative" style={{ width: size, height: size }} data-testid="score-ring">
      <svg viewBox="0 0 140 140" className="w-full h-full -rotate-90">
        <circle cx="70" cy="70" r={r} stroke="#e2e8f0" strokeWidth="12" fill="none" />
        <circle cx="70" cy="70" r={r} stroke={color} strokeWidth="12" fill="none" strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={c - (c * score) / 100} style={{ transition: "stroke-dashoffset 1s ease-out" }} />
      </svg>
      <div className="absolute inset-0 grid place-items-center">
        <span data-testid="score-value" className="font-display text-4xl font-extrabold text-slate-900">{score}%</span>
      </div>
    </div>
  );
};
